<template>
    <div class="container-card-launch">
        <div class="container-card-launch-header">
            <div :class="[{'progress': situation == 'Finalizado' }]" class="finished">
                {{ situation }}
            </div>

            <ui-menu-card icon="fal fa-cog" icon-size="15" @input="setMenu">
                <div v-if="load" class="load">
                    <ui-overlay-load />
                </div>
                <button
                    v-for='(button, index) in buttons'
                    :key="button.id"
                    :disabled="!(button.completed || button.editing)"
                    type="button" @click="link(button.link, index)">
                    {{button.name}}
                </button>
            </ui-menu-card>
        </div>

        <div class="container-card-launch-body">
            <div v-if="data && data.name" class="title">{{ data.name }}</div>
            <div v-if="data && data.product && data.product.name" class="subtitle">
                {{ data.product.name }}
            </div>
        </div>

        <div class="container-card-launch-footer">
            <div :class="{'launch-date':  situation === 'Finalizado'}" class="launch-date-finished">
                <em class="fal fa-calendar-alt" />
            </div>
            <span :class="[{'text':  situation === 'Finalizado'}]" class="text-finished">
                {{ dateBetween }}
            </span>
        </div>
    </div>
</template>

<script>
	import { launchDay } from '@/services/axios'
	import { uiOverlayLoad } from '@/components/ui'
	import uiMenuCard from '@/components/ui/menu-card'
	import {  defaultMenuList, buttonsMenu } from '../data.js'

	import { helpersMixin } from '@/mixins'

	import { mapActions } from 'vuex'

	const moment = require('moment')
    require('moment/locale/pt-br')

	export default {
		name: 'ui-launch-card',

		components: {
			uiMenuCard,
			uiOverlayLoad
		},

		mixins: [helpersMixin],

		props: {
			/**
			 * Dados referentes ao lançamento representado pelo card
			 */
			data: {
				type: [Array, Object],
				required: false,
				default() {
					return {}
				}
			},
		},

		data() {
			return {
				menuOptions: [...defaultMenuList()],
				buttons: [...buttonsMenu()],
				checkedSteps: [0], // Por padrão a primeira etapa foi executada durante a criação do lançamento
				load: false,
				stop: false
			}
		},

		computed: {
			/**
			 * Computed property que define a situação do lançamento
			 */
			situation() {
				const date = new Date()
				let value = 'Finalizado'
				if (moment(date).isBefore(this.data.date)) {
					value = 'Aguardando lançamento'

				} else if (moment(date).isBetween(this.data.date, this.data.date_end) ||
					moment(date).format('YYYY-MM-DD') === moment(this.data.date_end).format('YYYY-MM-DD')) {
					value = 'Em andamento'
				}

				return value
			},
			/**
			 * Computed property que formata o intervalo definido pelas datas de início e
			 * fim do lançamento
			 */
			dateBetween() {
				const init = moment(this.data.date).format('DD/MM/YYYY')
				const end = moment(this.data.date_end).format('DD/MM/YYYY')

				return `De ${init} á ${end}`
			}
		},

		methods: {
			...mapActions('launchDay', ['setConfig', 'setSteps']),
			/**
			 * Seta, de maneira recursiva, o menu do card referente ao lançamento, de acordo com as
			 * etapas de cadastro já executadas
			 */
			setMenu() {
				if (this.stop) return
				this.load = true

				// Links referentes às etapas 1, 2 e 3
				const links = ['points/launchday_id', 'boxes/launchday_id', 'categories/launchday_id']
				/**
				 * O index começa à partir de 1, pois a etapa 0 foi executada durante o cadastro do
				 * lançamento referente à este card
				 */
				const index = this.checkedSteps.length
				this.checkStep(index, links[index - 1])
			},
			/**
			 * Recebe o índice e o link referente à determinada etapa e verifica se esta já foi
			 * concluída
			 */
			checkStep(index, link) {
				if (link) {
					launchDay.get(link, this.data.id).then(async response => {
						if (response.data && response.data.length) {
							if (index === 3) {
								await this.checkSubcategories([...response.data])

							} else if (!this.checkedSteps.includes(index)) {
								this.checkedSteps.push(index)
							}

							return this.setMenu()
						} else {
							this.setMenuOptions()
						}
					})

				} else {
					let checked = false
					if (index === 4) {
						// Verifica se algum plano de pagamento foi cadastrado
						checked = !!(this.data.attributes.tableValues && this.data.attributes.tableValues.length)

					} else if (index === 5 &&
						this.data.attributes.tableValues &&
						this.isJSON(this.data.attributes.tableValues)) {
						// Verifica se existem regras de comissionamento cadastradas para os planos de pagamento
						const paymentPlans = JSON.parse(this.data.attributes.tableValues)
						checked = paymentPlans.some(plan => plan.commission && plan.commission.length)
					}

					if (checked) this.checkedSteps.push(index)
					if (!checked || index === 5) {
						this.setMenuOptions()

					} else if (index === 4) {
						this.setMenu()
					}
				}
			},
			/**
			 * Verifica se foram cadastradas subcategorias para todas as categorias
			 */
			checkSubcategories(categories) {
				return launchDay.getAll('subcategories').then(response => {
					const subcategoriesCatIds = Object.values(response.data).map(subcategory => subcategory.category_id)
					const allCategoriesHasSub = categories.every(category => subcategoriesCatIds.includes(category.id))

					if (response.data.length && allCategoriesHasSub) {
						this.checkedSteps.push(3)

					} else {
						this.setMenuOptions()
					}
				})
			},
			/**
			 * Ativa as opções de menu referentes às etapas de configuração já concluídas pelo usuário
			 */
			setMenuOptions() {
				// Interrompe a ativação dos menus
				this.stop = true
				this.buttons = [...new Set(this.buttons)]
				for (const index of this.checkedSteps) {
					this.buttons[index].completed = true
					this.menuOptions[index].completed = true
					this.menuOptions[index].editing = false
					this.menuOptions[index].seted = false
					// Ativa a próxima etapa se existir
					if (this.buttons[index + 1] && this.menuOptions[index + 1]) {
						this.buttons[index + 1].editing = true
						this.menuOptions[index + 1].editing = true
					}
				}
				this.load = false
			},
			/**
			 * Seta as configurações referentes ao lançamento e abre a etapa de configuração solicitada
			 */
			link(name, index) {
				var card = { ...this.data }
				delete card.product
				this.menuOptions[index].seted = true
				this.setConfig(card)
				this.setSteps(this.menuOptions)
				this.$router.push({ name })
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>